<template>
  <Layout>
    <PageHeader :title="page.title" :items="page.items" />

    <!-- main -->
    <b-row>
      <b-col lg="12">
        <!-- 查询条件 -->
        <b-card>
          <b-row>
            <b-col lg="3">
              <b-form-group
                label="Application Name"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="application-name"
              >
                <b-form-input
                  id="application-name"
                  v-model="search_condition.applicationName"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Affiliated Customer"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="customer"
              >
                <!-- <b-form-select
                  v-model="search_condition.supplierName"
                  :options="types.questionCategorys"
                  value-field="id"
                  text-field="name"
                >
                </b-form-select> -->
                <b-form-input
                  id="customer"
                  v-model="search_condition.supplierName"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-form-group
                label="Status"
                label-cols-sm="4"
                label-align-sm="right"
                label-for="status"
              >
                <b-form-select
                  v-model="search_condition.status"
                  :options="types.statuss"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col lg="3">
              <b-button variant="primary" @click="search()">Search</b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-card>
          <div class="table-responsive mb-0">
            <b-table
              show-empty
              empty-text="no records"
              id="table"
              head-variant="light"
              ref="table"
              :busy="isBusy"
              :striped="true"
              :items="provider"
              :fields="fields"
              :per-page="search_condition.pageSize"
              :current-page="search_condition.pageNum"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-includedfields="filterOn"
              @filtered="onFiltered"
            >
              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                {{
                  data.index +
                    (search_condition.pageNum - 1) * search_condition.pageSize +
                    1
                }}
              </template>

              <template v-slot:cell(actions)="row">
                <b-button-group>
                  <b-button
                    v-has="'application::Modify'"
                    size="sm"
                    variant="info"
                    @click="edit(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    Modify
                  </b-button>

                  <b-button
                    v-has="'application::App content settings'"
                    size="sm"
                    variant="primary"
                    @click="setting(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    App content settings
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
          </div>
          <!-- end table -->
          <!-- pagination -->
          <b-row v-if="has_data">
            <b-col>
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination  mb-0" v-if="rows != 0">
                  <b-pagination
                    v-model="search_condition.pageNum"
                    :per-page="10"
                    :total-rows="rows"
                    aria-controls="table"
                  >
                  </b-pagination>
                </ul>
              </div>
            </b-col>
          </b-row>
          <!-- end pagination -->
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import timeZoneConversion from "@/components/widgets/timeZoneConversion";

/**
 * FAQ component
 */
export default {
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  data() {
    return {
      page: {
        title: "Application Manage",
        items: [
          {
            text: "UNI-CORE",
            // href: "/"
          },
          {
            text: "App Manage",
            // href: "/"
          },
          {
            text: "Application Manage",
            active: true,
          },
        ],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { key: "index", label: "#", class: "text-center" },
        {
          key: "applicationName",
          label: "Application Name",
          class: "text-center",
        },
        // {
        //   key: "categoryId",
        //   label: "Affiliated Platform",
        //   class: "text-center",
        // },
        { key: "version", label: "Putaway Version", class: "text-center" },
        {
          key: "path",
          label: "Push The Path",
          formatter: (value) => {
            return value == 1
              ? "Supplement "
              : value == 2
              ? "Dime"
              : value == 3
              ? "Dime Test"
              : value == 4
              ? "Vaporizer"
              : "Vaporizer Test";
          },
        },
        {
          key: "supplierName",
          label: "Affiliated Customer",
          class: "text-center",
        },
        {
          key: "status",
          label: "Status",
          formatter: (value) => {
            return value == 1 ? "putaway" : "sold out";
          },
        },
        {
          key: "createTime",
          label: "Create Time",
          class: "text-center",
          formatter: (value) => {
            if (value) {
              return timeZoneConversion.getLocalTime(value);
            } else {
              return "";
            }
          },
        },
        { key: "actions", label: "Opreration", class: "text-center" },
      ],
      search_condition: {
        pageNum: 1,
        pageSize: 10,
        applicationName: "",
        supplierName: "",
        status: "",
      },
      isBusy: false,
      has_data: false,
      types: {
        statuss: [
          { text: "Please select", value: "", disabled: false },
          { text: "putaway", value: 1, disabled: false },
          { text: "sold out", value: 0, disabled: false },
        ],
      },
    };
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  created() {},
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    gotoAdd() {
      this.$router.push("applicationAdd");
    },
    provider(ctx) {
      this.isBusy = true;
      return this.$api.appManage
        .list(this.search_condition, ctx)
        .then((x) => {
          this.isBusy = false;
          if (x.total) {
            this.has_data = true;
            this.totalRows = x.total;
            return x.data;
          } else {
            this.has_data = false;
            return [];
          }
        })
        .catch((e) => {
          this.isBusy = false;
          this.has_data = false;
          return [];
        });
    },
    setting(item, index, button) {
      this.$router.push("settings?id=" + item.id);
    },
    edit(item, index, button) {
      this.$router.push("applicationEdit?id=" + item.id);
    },
    search() {
      this.search_condition.pageNum = 1;
      this.$refs.table.refresh();
    },
  },
};
</script>
